export function getClientConfig() {
  if (
    process.env.NODE_ENV !== "development"
  ) {
    return {
      PUBLIC_URL: '/',
      REACT_APP_GAME_START: '/api/bountyhunter/v1/game/start',
      REACT_APP_GAME_BET: '/api/bountyhunter/v1/game/bet',
      REACT_APP_GAME_END: '/api/bountyhunter/v1/game/end',
      REACT_APP_BALANCE: '/api/bountyhunter/v1/session/balance',
      REACT_APP_PAYOUTS: '/api/bountyhunter/v1/game/distribution-matrix',
      REACT_APP_ENV: 'PROD',
      REACT_APP_PROFILE: '/api/bountyhunter/v1/session/profile',
      REACT_APP_SKIN: '',
      REACT_APP_SENTRY_DSN: 'https://0c3a5b739f786f1d1dbc56c302db4ad9@o1406892.ingest.us.sentry.io/4508319409897472',
      REACT_APP_SENTRY_SAMPLE_RATE: '0',
      REACT_APP_MAINTENANCE_FLAGS_JSON_PATH: 'https://configs.pokerskins.io/maintenance.json',
    };
  }

  return {
      PUBLIC_URL: process.env.PUBLIC_URL,
      REACT_APP_GAME_START: process.env.REACT_APP_GAME_START,
      REACT_APP_GAME_BET: process.env.REACT_APP_GAME_BET,
      REACT_APP_GAME_END: process.env.REACT_APP_GAME_END,
      REACT_APP_BALANCE: process.env.REACT_APP_BALANCE,
      REACT_APP_PAYOUTS: process.env.REACT_APP_PAYOUTS,
      REACT_APP_ENV: process.env.REACT_APP_ENV,
      REACT_APP_PROFILE: process.env.REACT_APP_PROFILE,
      REACT_APP_SKIN: process.env.REACT_APP_SKIN,
      REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
      REACT_APP_SENTRY_SAMPLE_RATE: process.env.REACT_APP_SENTRY_SAMPLE_RATE,
      REACT_APP_MAINTENANCE_FLAGS_JSON_PATH: process.env.REACT_APP_MAINTENANCE_FLAGS_JSON_PATH,
  }
}

export type Config = ReturnType<typeof getClientConfig>;

export const getConfig = <T extends keyof Config>(key: T) => {
  const config = getClientConfig();
  return config[key];
}
